import React, { useState } from 'react';
import { CmisServicesRequestData, CmisServicesResponseData, TicketDetail, TransferCmis } from '../../types';
import { Dropdown, Input, Menu, message, Modal, Tooltip, Typography } from 'antd';
import { requestform } from '../../messages';
import { DownOutlined } from '@ant-design/icons';
import { CopyIcon, GreenCheck } from '../../assets';
import { usePatchTransferToCmisMutation } from '../../services';
import { GetCmisService } from '../../hooks/request-form';
import ModalCmisProcessingProgress from './Modal/ModalCmisProcessingProgress';
import { useLocation } from 'react-router-dom';

interface ticketCreateInformation {
  ticketDetail: TicketDetail;
  isHistory?: boolean;

  onActionSuccess?: () => void;
}

const DEFAULT_CMIS_SERVICE_REQUEST: CmisServicesRequestData = {
  pageIndex: 1,
  pageSize: 20,
  code: '',
  prefixCode: '',
  isLoadAll: true
};

function removeVietnameseTones(str: string) {
  return str
    .normalize('NFD') // Tách các dấu
    .replace(/[\u0300-\u036f]/g, '') // Xóa dấu
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();
}

const RequestDetailCmisTransferInformation: React.FC<ticketCreateInformation> = ({ ticketDetail, onActionSuccess }) => {
  const location = useLocation().pathname;
  const { cmisData } = GetCmisService(DEFAULT_CMIS_SERVICE_REQUEST);

  const [selectedOption, setSelectedOption] = useState<CmisServicesResponseData | null>(null);

  const [isOpenCmisProcess, setIsOpenCmisProcess] = useState(false);
  const openCmisProcess = () => setIsOpenCmisProcess(true);
  const closeCmisProcess = () => setIsOpenCmisProcess(false);

  const [transferCmisService] = usePatchTransferToCmisMutation();
  const transferCmis = () => {
    if (selectedOption === null) {
      message.error('Vui lòng chọn loại dịch vụ CMIS');
      return;
    }

    if (ticketDetail?.ticketId !== undefined) {
      const transferCmisServiceDto: TransferCmis = {
        ticketId: ticketDetail.ticketId,
        serviceTypeCmisId: selectedOption?.serviceTypeCmisId ? selectedOption?.serviceTypeCmisId : 0
      };
      transferCmisService(transferCmisServiceDto)
        .unwrap()
        .then((res) => {
          message.success('Chuyển Cmis thành công', 2);
          onActionSuccess && onActionSuccess();
        })
        .catch((err) => {
          message.error('Chuyển CMIS thất bại, vui lòng thực hiện lại');
        });
    }
  };
  const [searchKeyword, setSearchKeyword] = useState('');
  const normalizedKeyword = removeVietnameseTones(searchKeyword);

  const filteredOptions = cmisData.filter((option) => removeVietnameseTones(option.name).includes(normalizedKeyword));

  const handleMenuClick = (option: CmisServicesResponseData) => setSelectedOption(option);
  const menu = (
    <Menu className='max-h-[400px] overflow-y-auto rounded-md bg-[#F0F2F5] p-0 shadow-md'>
      <div className='sticky top-0 z-10 border-b-2 border-[#B0B6C3] bg-[#DDE3EB] p-2'>
        <Input
          placeholder='🔍 Tìm theo tên dịch vụ...'
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
          allowClear
          className='rounded-md border border-[#B0B6C3] bg-white px-3 py-1 text-sm font-medium text-[#141414] shadow-sm hover:border-[#1890FF] focus:border-[#1890FF]'
          size='small'
        />
      </div>

      {filteredOptions.length > 0 ? (
        filteredOptions.map((option) => (
          <Menu.Item
            key={option.serviceTypeCmisId}
            onClick={() => handleMenuClick(option)}
            className='flex h-[40px] items-center px-4 hover:bg-[#D6ECFF]'
          >
            <Typography.Text className='text-[14px]/[18px] text-[#141414]'>{option.name}</Typography.Text>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item disabled className='px-4 py-2 text-sm italic text-[#666]'>
          Không tìm thấy kết quả phù hợp
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <div>
      <Modal
        centered
        className='ant-modal-body-p-none w-[80vw] rounded-xl bg-[#FFFFFF]'
        open={isOpenCmisProcess}
        onCancel={closeCmisProcess}
        footer={null}
        destroyOnClose
      >
        <ModalCmisProcessingProgress cmisRequestId={ticketDetail.cmisRequestId} closeCmisProcess={closeCmisProcess} />
      </Modal>

      {ticketDetail.cmisRequestId ? (
        <button
          onClick={openCmisProcess}
          className='mt-1 flex w-full justify-between rounded-[5px] bg-[#06A77D00] py-[11px] hover:bg-[#F5F5F7]'
        >
          <div className='flex space-x-1'>
            <GreenCheck className='h-5 w-5' />
            <Typography.Text className='text-[19px]/[23px] italic text-[#141414]'>
              {requestform.cmisTranfered + ticketDetail?.cmisRequestId}
            </Typography.Text>
            {/* <button
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard
                  .writeText(ticketDetail?.cmisRequestId || "")
                  .then(() => {
                    message.success('Mã đã được sao chép!');
                  })
                  .catch(() => {
                    message.error('Sao chép thất bại, vui lòng thực hiện lại sau');
                  });
              }}
            >
              <Tooltip placement="right" title="Sao chép mã CMIS">
                <CopyIcon className={'hover:w-4 hover:h-4'}/>
              </Tooltip>
            </button> */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                const textToCopy = ticketDetail?.cmisRequestId || '';

                // Kiểm tra hỗ trợ Clipboard API và context bảo mật
                if (navigator.clipboard && window.isSecureContext) {
                  navigator.clipboard
                    .writeText(textToCopy)
                    .then(() => {
                      message.success('Mã đã được sao chép!');
                    })
                    .catch(() => {
                      message.error('Sao chép thất bại, vui lòng thực hiện lại sau');
                    });
                } else {
                  // Phương án dự phòng cho trình duyệt cũ
                  try {
                    const textArea = document.createElement('textarea');
                    textArea.value = textToCopy;
                    // Ẩn textarea khỏi màn hình
                    textArea.style.position = 'fixed';
                    textArea.style.left = '-999999px';
                    textArea.style.top = '-999999px';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    textArea.remove();
                    message.success('Mã đã được sao chép!');
                  } catch (err) {
                    message.error('Sao chép thất bại, vui lòng thực hiện lại sau');
                  }
                }
              }}
            >
              <Tooltip placement='right' title='Sao chép mã CMIS'>
                <CopyIcon className={'hover:h-4 hover:w-4'} />
              </Tooltip>
            </button>
          </div>{' '}
        </button>
      ) : ticketDetail?.status?.code !== 'HOANTAT' &&
        ticketDetail?.serviceType?.code !== 'baoMatDien' &&
        ticketDetail?.serviceType?.code !== 'anToanDien' &&
        ticketDetail?.serviceType?.code !== 'baoMatDienDoNo' ? (
        <div className='mt-1 flex justify-between rounded-[5px] border border-[#D1131D] bg-[#06A77D00] px-4 py-[11px]'>
          <div className='flex items-center space-x-2'>
            <Typography.Text className='text-[14px]/[18px] font-semibold text-[#D1131D]'>
              {requestform.cmisTransferFail}
            </Typography.Text>{' '}
            <Typography.Text className='text-[14px]/[18px] text-[#141414]'>
              {location !== '/profile' && (
                <Dropdown overlay={menu} className={''} trigger={['click']}>
                  <div className='flex w-full cursor-pointer items-center justify-between space-x-2 border-[#EBEBED] bg-[#FFFFFF]'>
                    <Typography.Text className='text-[14px]/[18px]'>
                      {selectedOption?.name ? selectedOption?.name : requestform.typeCmisTicket}
                    </Typography.Text>
                    <DownOutlined className='h-2 w-[10px]' />
                  </div>
                </Dropdown>
              )}
            </Typography.Text>{' '}
          </div>
          <button onClick={transferCmis}>
            <Typography.Text className='text-[14px]/[18px] text-[#1564E8]'>
              {location !== '/profile' ? requestform.tryAgainButton : ''}
            </Typography.Text>
          </button>
        </div>
      ) : (
        <div className='mt-1 flex justify-between rounded-[5px] border border-[#D1131D] bg-[#06A77D00] px-4 py-[11px]'>
          <div className='flex items-center space-x-2'>
            <Typography.Text className='text-[14px]/[18px] font-semibold text-[#D1131D]'>
              {requestform.cmisTransferFail}
            </Typography.Text>{' '}
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestDetailCmisTransferInformation;
